import { gql } from 'apollo-boost';

export default gql`
  query GetUserSessionId($userId: uuid!) {
    user: user_by_pk(id: $userId) {
      sessionId: session_id
    }
  }
`;
